import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const CategoryDropDownItem = memo(
  ({ selectedItem: { id: selectedId } = {}, item: { id, title } }) => {
    const { styles } = useStyle();
    const isSelected = selectedId === id;
    return (
      <View style={[styles.container, isSelected && styles.containerSelected]}>
        <Text style={[styles.text, isSelected && styles.textSelected]}>
          {title}
        </Text>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {
    paddingHorizontal: 8,
    paddingVertical: 16,
  },
  containerSelected: {
    backgroundColor: colors.blue4,
    borderRadius: 5,
  },
  text: {
    colors: colors.gray21,
    fontSize: 14,
  },
  textSelected: {
    colors: colors.blue1,
  },
}));
